// Generated by purs version 0.11.7
"use strict";
var $foreign = require("./foreign");
var Control_Applicative = require("../Control.Applicative");
var Control_Monad_Except_Trans = require("../Control.Monad.Except.Trans");
var Control_Semigroupoid = require("../Control.Semigroupoid");
var Data_Eq = require("../Data.Eq");
var Data_Foreign = require("../Data.Foreign");
var Data_Functor = require("../Data.Functor");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra");
var Data_Identity = require("../Data.Identity");
var Data_Maybe = require("../Data.Maybe");
var Data_Newtype = require("../Data.Newtype");
var Data_Ord = require("../Data.Ord");
var Data_Semigroup = require("../Data.Semigroup");
var Data_Show = require("../Data.Show");
var Prelude = require("../Prelude");
var NullOrUndefined = function (x) {
    return x;
};
var unNullOrUndefined = function (v) {
    return v;
};
var readNullOrUndefined = function (v) {
    return function (value) {
        if (Data_Foreign.isNull(value) || Data_Foreign.isUndefined(value)) {
            return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Data_Maybe.Nothing.value);
        };
        return Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(function ($23) {
            return NullOrUndefined(Data_Maybe.Just.create($23));
        })(v(value));
    };
};
var newtypeNullOrUndefined = new Data_Newtype.Newtype(function (n) {
    return n;
}, NullOrUndefined);
var showNullOrUndefined = function (dictShow) {
    return new Data_Show.Show(function (x) {
        return "(NullOrUndefined " + (Data_Show.show(Data_Maybe.showMaybe(dictShow))(Data_Newtype.unwrap(newtypeNullOrUndefined)(x)) + ")");
    });
};
var eqNullOrUndefined = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(dictEq))(x)(y);
        };
    });
};
var ordNullOrUndefined = function (dictOrd) {
    return new Data_Ord.Ord(function () {
        return eqNullOrUndefined(dictOrd.Eq0());
    }, function (x) {
        return function (y) {
            return Data_Ord.compare(Data_Maybe.ordMaybe(dictOrd))(x)(y);
        };
    });
};
module.exports = {
    NullOrUndefined: NullOrUndefined,
    unNullOrUndefined: unNullOrUndefined,
    readNullOrUndefined: readNullOrUndefined,
    newtypeNullOrUndefined: newtypeNullOrUndefined,
    eqNullOrUndefined: eqNullOrUndefined,
    ordNullOrUndefined: ordNullOrUndefined,
    showNullOrUndefined: showNullOrUndefined,
    "undefined": $foreign["undefined"]
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Foreign.NullOrUndefined/index.js
// module id = 580
// module chunks = 0